import { useEffect, useRef, useState } from "react";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full min-h-[420px] md:min-h-[560px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Serene%20modern%20wellness%20spa%20interior%20with%20lush%20green%20plants%20natural%20wood%20tones%20and%20soft%20warm%20lighting%20peaceful%20minimalist%20atmosphere%20relaxing%20healthcare%20environment%20cinematic%20photography%20shallow%20depth%20of%20field&width=1600&height=900&seq=about-hero-bg&orientation=landscape"
          alt="Không gian Xanh Wellness"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/50 to-primary-950/70" />
      </div>

      <div
        className={`relative z-10 w-full text-center px-4 md:px-8 py-20 md:py-28 transition-all duration-1000 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-xs md:text-sm font-label font-medium rounded-full mb-5 border border-background-50/20">
          <i className="ri-leaf-line" />
          Về Xanh Wellness
        </span>
        <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 max-w-4xl mx-auto">
          Câu chuyện chăm sóc
          <br className="hidden md:block" />
          <span className="text-accent-400">từ tâm</span>
        </h1>
        <p className="text-sm md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed font-body">
          Xanh Wellness ra đời từ một niềm tin giản dị: sức khỏe là nền tảng của hạnh phúc. Chúng tôi mang công nghệ chăm sóc hiện đại đến gần hơn với mỗi gia đình Việt.
        </p>
      </div>
    </section>
  );
}